import Image from 'next/image'
import {useRouter} from 'next/router'
import Link from 'next/link'
import type {JSX} from 'react'
import {Icon as CIcon} from '@/_new-code/products/flexible-web-toolkit/components/icon'
import {loadImageFromKontentAI} from '@/imageLoader'
import {logout, useAuth} from '@/_new-code/products/auth/auth-provider'
import type {Tersed} from '@/_new-code/services/kontent-ai/types'
import type {IconContentItem} from '@/_new-code/products/flexible-web-toolkit/blocks/icon'
import type {
	AuthNavItemLinkContentItem,
	NavItemLinkContentItem,
} from '@/_new-code/products/flexible-web-toolkit/components/header/models'

interface AccountDropdownProps {
	accountIcon: Tersed<IconContentItem>[]
	greetingText: string
	navLinks: Tersed<AuthNavItemLinkContentItem | NavItemLinkContentItem>[]
}

export const AccountDropdown = ({
	accountIcon,
	greetingText,
	navLinks,
}: AccountDropdownProps): JSX.Element => {
	const authState = useAuth()
	const router = useRouter()
	const {firstName, lastName, salutation} = authState.userDetails
	let greetingTexts = greetingText
	if (
		greetingText &&
		firstName &&
		lastName &&
		salutation &&
		greetingText.includes('{{lastName}}')
	) {
		greetingTexts = greetingText
			.replace(/{{firstname}}/gi, '')
			.replace(/{{lastName}}/gi, `${salutation}  ${lastName}`)
	} else {
		greetingTexts = greetingText
			.replace(/{{firstname}}/gi, firstName)
			.replace(/{{lastname}}/gi, lastName)
	}

	return (
		<div className="account-dropdown">
			<button type="button">
				{accountIcon[0]
					? accountIcon.map((icon) => (
							<CIcon
								className="h-8 w-8"
								key={icon.system.id}
								noBackground
								noBorder
							>
								<Image
									alt={
										icon.elements.icon[0]?.description ?? ''
									}
									className="h-8 w-8"
									height={32}
									loader={loadImageFromKontentAI}
									src={icon.elements.icon[0]?.url || ''}
									width={32}
								/>
							</CIcon>
						))
					: null}
				<span>{greetingTexts}</span>
			</button>
			<div className="nav-link-container">
				<ul>
					{navLinks.map((link) => (
						<li key={link.system.id}>
							<Link
								className="inline-block w-full cursor-pointer py-3"
								href={link.elements.url}
								onClick={() => {
									if (
										link.elements.logoutUser[0]
											?.codename === 'yes'
									) {
										logout(router, link.elements.url || '/')
									}
								}}
								passHref
							>
								{}

								{link.elements.text}
							</Link>
						</li>
					))}
				</ul>
			</div>
		</div>
	)
}
